import UserCard from "../components/UserCard";
import '../css/contact-us.css'
import vishwa from '../images/vishwa.jpg'
import mahaveer from '../images/MyPicture.jpg'
import pradeep from '../images/pradeep.jpg'
import aashath from '../images/aashath.jpg'
import nagappan from '../images/nagappan.jpg'

export default function ContactUs() {
    return (
        // <><h1 style={{'color':'aliceblue','margin':'20px','fontSize':'18px'}}>Contact Information will be added here !</h1></>
        <div className='contact-us'>
            <div className="contact-us-title">
                <p><span className="pink">&#47;&#47;</span> Staff Coordinators</p>
            </div>
            <div className="contact-us-content">
                <UserCard 
                    name='Teacher name 1' 
                    phone='1234567890'
                    // img={nagappan}
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                />
                <UserCard 
                    name='Teacher name 2'
                    phone='1234567890' 
                    // img={aashath}
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                />
                <UserCard 
                    name='Teacher name 3' 
                    phone='1234567890' 
                    // img={mahaveer}
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                />
                <UserCard 
                    name='Teacher name 4'
                    phone='1234567890' 
                    // img={pradeep}
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                />
            </div>
            <div className="contact-us-title">
                <p><span className="pink">&#47;&#47;</span> Event Coordinators</p>
            </div>
            <div className="contact-us-content">
                <UserCard 
                    name='Nagappan' 
                    phone='1234567890'
                    img={nagappan}
                    github='https://github.com/Mahaveer1013?tab=repositories'
                    linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                    portfolio='https://mahaveer-my-portfolio.netlify.app'
                />
                <UserCard 
                    name='Aashath'
                    phone='1234567890' 
                    img={aashath}
                    github='https://github.com/Mahaveer1013?tab=repositories'
                    linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                    portfolio='https://mahaveer-my-portfolio.netlify.app'
                />
                <UserCard 
                    name='Mahaveer' 
                    phone='1234567890' 
                    img={mahaveer}
                    github='https://github.com/Mahaveer1013?tab=repositories'
                    linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                    portfolio='https://mahaveer-my-portfolio.netlify.app'
                />
                <UserCard 
                    name='Pradeep'
                    phone='1234567890' 
                    img={pradeep}
                    github='https://github.com/Mahaveer1013?tab=repositories'
                    linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                    portfolio='https://mahaveer-my-portfolio.netlify.app'
                />
                <UserCard 
                    name='Vishwanathan'
                    phone='1234567890'
                    img={vishwa}
                    github='https://github.com/Mahaveer1013?tab=repositories'
                    linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                    gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                    portfolio='https://mahaveer-my-portfolio.netlify.app'
                />
            </div>
        </div>
    )
}